import { ArrowUpRight, Menu, Phone } from "lucide-react";

export function SiteHeader({ copy, content, language, onLanguageChange, onQuote }) {
  return (
    <header className="site-header" data-testid="site-header">
      <a href="#top" className="brand-lockup" data-testid="brand-home-link" aria-label={content.company_name}>
        <img src={content.logo_url} alt={`${content.company_name} logo`} />
        <span><strong>ESPINOZA</strong><small>TREE SERVICE</small></span>
      </a>
      <nav className="header-nav" aria-label="Primary navigation">
        <a href="#services" data-testid="nav-services-link">{copy.nav.services}</a>
        <a href="#approach" data-testid="nav-approach-link">{copy.nav.approach}</a>
        <a href="#crew-equipment" data-testid="nav-crew-link">{copy.nav.crew}</a>
        <a href="#field-notes" data-testid="nav-work-link">{copy.nav.work}</a>
      </nav>
      <div className="header-actions">
        <a className="header-phone" href={`tel:${content.phone_primary.replaceAll("-", "")}`} data-testid="nav-phone-link"><Phone size={15} /> {copy.nav.call}</a>
        <button className="language-toggle" type="button" onClick={onLanguageChange} data-testid="nav-language-toggle" aria-label={`Switch to ${copy.nav.language}`}>
          <span>{language.toUpperCase()}</span><span className="toggle-slash">/</span><span className="toggle-next">{copy.nav.language}</span>
        </button>
        <button className="button button--small header-cta" type="button" onClick={onQuote} data-testid="nav-request-estimate-btn">{copy.nav.quote}<ArrowUpRight size={15} /></button>
        <button className="mobile-menu-button" type="button" aria-label="Open navigation" data-testid="mobile-menu-button"><Menu size={20} /></button>
      </div>
    </header>
  );
}
